import {
    apiTransitionPayloadCollection,
    submitPayloadDataSuccess
} from '../../../actions/motorPrivateRW/payloadCollection';
import { getAccessToken, getPaymentsForm } from '../../../selectors/motorPrivateRW/payments';
import axios from 'axios';
import { getApiQuoteResponse } from '../../../selectors/motorPrivateRW/quote';
import { apiTransitionPaymentsStatus } from '../../../actions/motorPrivateRW/payments';
import { getPersonalDetailsForm } from '../../../selectors/motorPrivateRW/personalDetails';

export const savePaymentsService = (store, next, action) => {
    (async () => {
        store.dispatch(apiTransitionPayloadCollection.pending());
        try {
            const paymentForm = getPaymentsForm(store.getState());
            const savedQuoteResponse = getApiQuoteResponse(store.getState());
            const quoteId = savedQuoteResponse?.data?.quotation?.id;
            const resp = await savePayments(store.getState());
            store.dispatch(submitPayloadDataSuccess(resp.data));
            store.dispatch(apiTransitionPayloadCollection.success());
            if (paymentForm.networkProvider.value === 'mtn') {
                checkPaymentStatus(store, quoteId);
            }
        } catch (e) {
            console.error(e);
            store.dispatch(apiTransitionPayloadCollection.failure());
        }
    })();
    return next(action);
};

const savePaymentsPayload = state => {
    const savedQuoteResponse = getApiQuoteResponse(state);
    const quoteId = savedQuoteResponse?.data?.quotation?.id;
    const payments = getPaymentsForm(state);
    const personalDetails = getPersonalDetailsForm(state);


    const payload = {
        quoteId,
        modeOfPayment: payments.networkProvider.value === 'mtn' ? 'MTN' : 'BANK', //mtn or MTN or BANK or Bank
        phoneNumber: payments.networkProvider.value === 'mtn' ? payments.phoneNumber.value : personalDetails.phoneNumber.value
    };

    // Change payload here
    return {
        ...payload
    };
};

const savePayments = async state => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/rw-motor-insurance/save/payment';
        return await axios.post(url, savePaymentsPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                Cookie: 'devEnvironment=ea-qa'
            }
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

const checkPaymentStatus = async (store, quoteId) => {
    const MAX_DURATION = 300000; // 5 minutes (300 seconds)
    const INTERVAL = 2000; // 2 seconds
    let elapsedTime = 0;
    const loginData = getAccessToken(store.getState());

    return new Promise((resolve, reject) => {
        const intervalId = setInterval(async () => {
            try {
                store.dispatch(apiTransitionPaymentsStatus.pending());
                const response = await axios.post(
                    `/om-api/rw-motor-insurance/verify/payment`,
                    {
                        quoteId
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            accessToken: loginData.accessToken
                        }
                    }
                );

                if (response?.data.status === 200) {
                    clearInterval(intervalId);
                    store.dispatch(apiTransitionPaymentsStatus.success());
                    resolve(response.data);
                } else if (elapsedTime >= MAX_DURATION) {
                    clearInterval(intervalId);
                    store.dispatch(apiTransitionPaymentsStatus.failure());
                    reject(new Error('Payment verification timed out.'));
                }

                elapsedTime += INTERVAL;
            } catch (error) {
                console.error('Error checking payment status:', error);
            }
        }, INTERVAL);
    });
};
